import type RBush from 'rbush';
import { useMemo } from 'react';

import { useMapStoreContext } from '@/microfrontends/map/shared/context/mapStoreContext';
import { type RBushItem } from '@/microfrontends/map/shared/types/Map';

type UseInitHotspotsLayerParams = {
  rbush: RBush<RBushItem>;
};

export function useInitHotspotsLayer({ rbush }: UseInitHotspotsLayerParams): YMaps.HotspotsLayer {
  const { ymaps, map } = useMapStoreContext();

  return useMemo(() => new ymaps.HotspotsLayer({ map, rbush }), [map, rbush, ymaps.HotspotsLayer]);
}
